<template>
  <main class="section">
    <div class="container">
      <b-loading
        :is-full-page="isFullPage"
        :active.sync="isLoading"
      ></b-loading>
      <SingleIndicator v-if="isVisible"></SingleIndicator>
    </div>
  </main>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Table",
  components: {
    SingleIndicator: () =>
      import(
        /* webpackChunkName: "SingleIndicator" */ "@/components/indicators/SingleIndicator.vue"
      )
  },
  mounted() {
    this.openLoading();
    this.getTableData(this.$route.params.id).then(() => this.closeLoading());
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      isFullPage: true
    };
  },
  methods: {
    ...mapActions("table", {
      getTableData: "getTableData"
    }),
    openLoading() {
      this.isLoading = true;
    },
    closeLoading() {
      this.isLoading = false;
      this.isVisible = true;
    }
  }
};
</script>
